<template>
  <input v-model="modelColor" class="ak-color-picker__control" />
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-color-picker-color-input />
   */
  name: 'AkColorPickerColorInput',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    color: {
      type: String,
      default: '',
    },
  },

  emits: ['inputColor'],

  setup(props, { emit }) {
    const modelColor = computed({
      get() {
        return props.color
      },
      set(val) {
        emit('inputColor', val)
      },
    })

    return {
      modelColor,
    }
  },
})
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../scss/_settings.scss';
.ak-color-picker {
  &__control {
    border: 0;
    outline: 0;
    width: 100%;
    height: 28px;
    padding: 0;
    font-family: $base-font-family;
    font-size: $base-font-size;
    color: $color-text;
  }
}
</style>
